import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { deleteDialogData } from '../../../page/templates/templates.component';

@Component({
    selector: 'app-delete-board-task-dialog',
    templateUrl: './delete-board-task-dialog.component.html',
    styleUrls: ['./delete-board-task-dialog.component.scss'],
    standalone: false ,  // NOSONAR
})

export class DeleteBoardTaskDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DeleteBoardTaskDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataStore: deleteDialogData) { }

  ngOnInit(): void { // NOSONAR
		//  do something 
	}
  onNoClick(): void {
    this.dialogRef.close();
  }
  close(): void {
    this.dialogRef.close();
  }
  public saveClick() {
    this.dialogRef.close({ action: 'confirm' });

  }
}
